import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-dates";
import moment from "moment";

import "react-dates/initialize";

interface DateSelectorProps {
  startDate: moment.Moment;
  setStartDate: React.Dispatch<moment.Moment>;
  endDate: moment.Moment;
  setEndDate: React.Dispatch<moment.Moment>;
  minNights?: number;
  maxDate?: moment.Moment;
  minDate?: moment.Moment;
}

const DateSelector: React.FC<DateSelectorProps> = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  minNights = 1,
  maxDate,
  minDate,
}) => {
  const [focusedInput, setFocusedInput] = useState<
    "startDate" | "endDate" | null
  >(null);

  useEffect(() => {
    const input = document.querySelectorAll(".DateInput_input");
    if (input) {
      input.forEach((i) => {
        i.setAttribute("readonly", "readonly");
      });
    }
  }, []);

  return (
    <section className="date-range-small rounded-lg bg-light">
      <DateRangePicker
        startDate={startDate}
        startDateId="startDate"
        endDate={endDate}
        orientation={window.innerWidth < 640 ? "vertical" : "horizontal"}
        verticalHeight={360}
        endDateId="endDate"
        minDate={minDate}
        isOutsideRange={(day) =>
          (maxDate && day.isAfter(maxDate)) ||
          (minDate && day.isBefore(minDate, "day"))
        }
        maxDate={maxDate}
        displayFormat="ddd D MMM, YYYY"
        hideKeyboardShortcutsPanel
        minimumNights={minNights}
        onDatesChange={({ startDate, endDate }) => {
          if (startDate) {
            setStartDate(startDate);
          }
          if (endDate) {
            setEndDate(endDate);
          }
        }}
        focusedInput={focusedInput}
        onFocusChange={(focusedInput) => {
          setFocusedInput(focusedInput);
        }}
        noBorder
      />
    </section>
  );
};

export default DateSelector;
